import axios from "axios";
import { motion } from "framer-motion";
import { useState } from "react";
import {
  FaBullseye,
  FaCheckCircle,
  FaEye,
  FaHandsHelping,
  FaStar,
} from "react-icons/fa";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import buet from "./cse_buet.png"; // Adjust the path as necessary
import "./login.css";
import warpo from "./warpo.png"; // Adjust the path as necessary
const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [emailError, setEmailError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

    if (name === "email") {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      setEmailError(emailPattern.test(value) ? "" : "Invalid email address");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (emailError) {
      alert("Please enter a valid email before logging in.");
      return;
    }

    try {
      const response = await axios.post("https://warpo-dashboard.cse.buet.ac.bd/api/login", {
        email: formData.email,
        password: formData.password,
      });

      console.log(response)
      const { token, user, role } = response.data;


      // Save token to localStorage or a context
      localStorage.setItem("token", token);
      // Save user role
      localStorage.setItem("role", role);

      // Navigate to dashboard or any protected route
      window.location.href = "/home";

    } catch (error) {
      if (error.response) {
        alert(error.response.data.message || "Login failed. Please try again.");
      } else {
        alert("Server error. Please try again later.");
      }
    }
  };





  return (
    <div className="login-container">
      <div className="left-card">
        <h1 className="welcome-title">Welcome to the Data Imputation, Anomaly Correction and Forecasting Dashboard!</h1>
        <div className="mvf-grid">


          <div className="mvf-box vision">
            <h2>
              <FaEye className="mvf-icon" /> Vision
            </h2>
            <ul>
              <li>
                <FaCheckCircle className="bullet-icon" /> Transparent access
              </li>
              <li>
                <FaCheckCircle className="bullet-icon" /> Empower communities
              </li>
              <li>
                <FaCheckCircle className="bullet-icon" /> Encourage innovation
              </li>
            </ul>
          </div>

          <div className="mvf-box mission">
            <h2>
              <FaBullseye className="mvf-icon" /> Mission
            </h2>
            <ul>
              <li>
                <FaCheckCircle className="bullet-icon" /> Provide secure tools
              </li>
              <li>
                <FaCheckCircle className="bullet-icon" /> Enable data insights
              </li>
              <li>
                <FaCheckCircle className="bullet-icon" /> Support sustainability
              </li>
            </ul>
          </div>

          <div className="mvf-box focus">
            <h2>
              <FaStar className="mvf-icon" /> Focus
            </h2>
            <ul>
              <li>
                <FaCheckCircle className="bullet-icon" /> Groundwater monitoring
              </li>
              <li>
                <FaCheckCircle className="bullet-icon" /> Intuitive dashboards
              </li>
              <li>
                <FaCheckCircle className="bullet-icon" /> Real-time access
              </li>
            </ul>
          </div>

          <div className="mvf-box contribution">
            <h2>
              <FaHandsHelping className="mvf-icon" /> Contribution
            </h2>
            <ul>
              <li>
                <FaCheckCircle className="bullet-icon" /> Empower research
              </li>
              <li>
                <FaCheckCircle className="bullet-icon" /> Support local planning
              </li>
              <li>
                <FaCheckCircle className="bullet-icon" /> Aid policy decisions
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-logos">
          <img src={buet} alt="BUET Logo" />
          <img src={warpo} alt="WARPO Logo" />
        </div>
      </div>

      <motion.div
        className="right-login-box"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h2 className="login-title">Log In to Your Account</h2>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-field">
            <input
              id="login-email"
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              autoComplete="email"
              required
            />
            {emailError && <p className="error-message">{emailError}</p>}
          </div>

          <div className="form-field">
            <div className="password-field">
              <input
                id="login-password"
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                aria-pressed={showPassword}
              >
                {showPassword ? (
                  <IoEyeOffOutline size={22} aria-hidden />
                ) : (
                  <IoEyeOutline size={22} aria-hidden />
                )}
              </button>
            </div>
          </div>
          {/* <div className="forgot-password-link">
            <a href="/forgot-password">Forgot Password?</a>
          </div> */}
          <button type="submit" className="login-button">
            Log In
          </button>

          {/* Forgot Password */}
        </form>
      </motion.div>
    </div>
  );
};

export default Login;
